import { UserRole } from "./enums";

export interface SideNavItem {
  label: string;
  icon?: string;
  routePath?: string;
  requiredRoles?: UserRole[];
  expanded?: boolean;
  group?: string;
  badge?: number;      
}

export const SIDE_NAV_ITEMS: SideNavItem[] = [
  {
    label: 'Dashboard',
    icon: 'assets/icons/dashboard-icon.svg',
    routePath: '/dashboard',
    group: 'OPERATE',
    requiredRoles: [
      UserRole.ADMIN, UserRole.SUPER_ADMIN,
      UserRole.CS_AGENT, UserRole.CS_SUPERVISOR, UserRole.FLEET_MANAGER,
    ],
  },
  {
    label: 'Vehicles',
    icon: 'assets/icons/vehicle-icon.svg',
    group: 'OPERATE',
    routePath:'/vehicles',
    // items: [
    //   { label: 'Vehicles', routePath: '/vehicles' },
    //   { label: 'Models',   routePath: '/models'   },
    // ],
    requiredRoles: [
      UserRole.ADMIN, UserRole.SUPER_ADMIN, UserRole.CS_SUPERVISOR,
    ],
    // badge:35
  },
  {
    label: 'Customers',
    icon: 'assets/icons/customers-icon.svg',
    routePath: '/customers',
    group: 'OPERATE',
    requiredRoles: [
      UserRole.ADMIN, UserRole.SUPER_ADMIN,
      UserRole.CS_AGENT, UserRole.CS_SUPERVISOR, UserRole.FLEET_MANAGER,
    ],
  },
  {
    label: 'Customer Groups',
    icon: 'assets/icons/customers-icon.svg',
    group: 'OPERATE',
    routePath: '/customer-groups',
    requiredRoles: [UserRole.ADMIN, UserRole.SUPER_ADMIN],
  },
  {
    label: 'Employees',
    icon: 'assets/icons/employee-icon.svg',
    routePath: '/employees',
    group: 'OPERATE',
    requiredRoles: [
      UserRole.ADMIN, UserRole.SUPER_ADMIN, UserRole.FLEET_MANAGER,
    ],
  },
  {
    label: 'Rides',
    icon: 'assets/icons/rides-icon.svg',
    group: 'OPERATE',
    routePath:'/rides',
    // badge:35,
    // items: [
    //   { label: 'Rental',       routePath: '/rental-rides' },
    //   { label: 'Sharing',      routePath: '/sharing-rides' },
    //   { label: 'Reservations', routePath: '/reservations'  },
    // ],
    requiredRoles: [
      UserRole.ADMIN, UserRole.SUPER_ADMIN,
      UserRole.CS_AGENT, UserRole.CS_SUPERVISOR, UserRole.FLEET_MANAGER, UserRole.DRIVER,
    ],
  },

  // ── REVIEW ──────────────────────────────────────────────
  {
    label: 'Verification',
    icon: 'assets/icons/verification-icon.svg',
    routePath: '/ride-verification',
    group: 'REVIEW',
    // badge:35,
    requiredRoles: [
      UserRole.ADMIN, UserRole.SUPER_ADMIN,
      UserRole.CS_AGENT, UserRole.CS_SUPERVISOR, UserRole.FLEET_MANAGER,
    ],
  },
  {
    label: 'Damage',
    icon: 'assets/icons/damage-icon.svg',
    routePath: '/damage-reports',
    group: 'REVIEW',
    // badge:35,
    requiredRoles: [
      UserRole.ADMIN, UserRole.SUPER_ADMIN,
      UserRole.FLEET_MANAGER, UserRole.CS_AGENT, UserRole.CS_SUPERVISOR,
    ],
  },
  {
    label: 'Transaction history',
    icon: 'assets/icons/history-icon.svg',
    group: 'REVIEW',
    // badge:35,
    routePath: '/payment-transaction-history',
    // items: [
    //   { label: 'Payment Transactions', routePath: '/payment-transaction-history' },
    //   { label: 'Wallet Transactions',  routePath: '/wallet-transaction-history'  },
    // ],
    requiredRoles: [
      UserRole.ADMIN, UserRole.SUPER_ADMIN,
      UserRole.CS_AGENT, UserRole.CS_SUPERVISOR,
    ],
  },

  // ── CONFIGURE ───────────────────────────────────────────
  {
    label: 'Plans',
    icon: 'assets/icons/plans-icon.svg',
    routePath: '/plans',
    group: 'CONFIGURE',
    requiredRoles: [UserRole.ADMIN, UserRole.SUPER_ADMIN],
  },
  // {
  //   label: 'Zones',
  //   icon: 'assets/icons/iot.svg',
  //   routePath: '/zones',
  //   group: 'CONFIGURE',
  //   requiredRoles: [UserRole.ADMIN, UserRole.SUPER_ADMIN],
  // },
  {
    label: 'IOT',
    icon: 'assets/icons/IOT-icon.svg',
    group: 'CONFIGURE',
    routePath: '/iot',
    requiredRoles: [UserRole.ADMIN, UserRole.SUPER_ADMIN],
  },
  {
    label: 'Alerts',
    icon: 'assets/icons/bell.svg',
    group: 'CONFIGURE',
    routePath: '/alerts',
    requiredRoles: [UserRole.ADMIN, UserRole.SUPER_ADMIN],
  },
  {
    label: 'Campaigns',
    icon: 'assets/icons/bell.svg',
    group: 'CONFIGURE',
    routePath: '/campaigns',
    requiredRoles: [UserRole.ADMIN, UserRole.SUPER_ADMIN],
  },

  //   {
  //   label: 'Payment Webhook',
  //   icon: 'assets/icons/settings.svg',
  //   group: 'Temp',
  //   routePath:'payment-webhook',
  //   requiredRoles: [UserRole.ADMIN, UserRole.SUPER_ADMIN],
  // },
];
